import Image from 'next/image'
import { Button, Typography } from '@themenu/design-system'

import recardingPreferenceSurveyLogo from 'lib/assets/images/svg/recarding-preference-survey-logo.svg'

import { useSessionStore } from 'store/session'

import { useRecardingPreferenceSurveyStore } from '../../store'

export const IntroductionStep = () => {
  const { user } = useSessionStore()
  const { setStep } = useRecardingPreferenceSurveyStore()

  return (
    <div className="flex flex-col items-center gap-32">
      <Image
        src={recardingPreferenceSurveyLogo}
        alt="Recarding Preference Survey Logo"
        priority
      />
      <Typography variant="body">
        Olá {user.name}, estamos atualizando nossa tecnologia para oferecer
        ainda mais segurança, estabilidade e rapidez no uso dos benefícios.
      </Typography>
      <span>
        <Typography variant="body">
          Em breve realizaremos a{' '}
          <strong>troca dos cartões de todos seus colaboradores</strong>, sem
          nenhum custo adicional. Para que essa etapa aconteça com total
          previsibilidade, precisamos que você indique{' '}
          <strong>como prefere que o envio seja realizado</strong>. Vamos lá?
        </Typography>
      </span>
      <span>
        <Typography variant="caption" className="text-content-subdued italic">
          Em caso de dúvidas, acesse nossa{' '}
          <a
            href="https://beneficios.swile.co/pt-br/recarding-rh-swile"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            <strong>página informativa</strong>
          </a>{' '}
          ou entre em contato pelos nossos canais oficiais. Acompanhe nossas
          comunicações para detalhes sobre próximos passos.
        </Typography>
      </span>
      <div className="flex self-stretch flex-col-reverse justify-center gap-8 md:flex-row">
        <Button
          size={40}
          endIcon="arrow-right"
          onClick={() => setStep('recarding-preference-question')}
        >
          Prosseguir
        </Button>
      </div>
    </div>
  )
}
